import { readOrganizationIDsByUser } from '@usehatchapp/javascript-sdk';
import isCorrectHatchIdFormat from 'utils/isCorrectHatchIdFormat';

import { SET_FRESH_USER_KEY } from '../../fresh';
import { USER_ORGANIZATIONS } from '../../fresh/schema';
import { constants } from '../constants';

// TODO: This is not used by the current account settings flow, as we only care about
// users who are managers of organizations
export const doReadOrganizationsByUser =
  ({ userId } = {}) =>
  async ({ dispatch, request }) => {
    const {
      READ_ORGANIZATIONS_BY_USER_FAILURE,
      READ_ORGANIZATIONS_BY_USER_REQUEST,
      READ_ORGANIZATIONS_BY_USER_SUCCESS,
    } = constants;

    try {
      if (!isCorrectHatchIdFormat(userId)) {
        throw new Error('Invalid userId format');
      }

      // tell state we're fetching organizations by user
      dispatch({ type: READ_ORGANIZATIONS_BY_USER_REQUEST });

      // fetch organization IDs as array
      const organizationsResponse = await request(readOrganizationIDsByUser, {
        userId,
      });

      // reduce organization IDs into store
      dispatch({
        actions: [
          {
            payload: { organizationsByUser: organizationsResponse || [] },
            type: READ_ORGANIZATIONS_BY_USER_SUCCESS,
          },
          {
            payload: { fresh: true, key: USER_ORGANIZATIONS },
            type: SET_FRESH_USER_KEY,
          },
        ],
        type: 'BATCH_ACTIONS',
      });
    } catch (error) {
      dispatch({ error, type: READ_ORGANIZATIONS_BY_USER_FAILURE });
    }
  };
